module.exports = __webpack_public_path__ + "static/media/RAFAC.ef872c3e.jpg";